<template>
    <div class="page" v-if="isLoaded">
        <TopBar
            :label="lbl.topbar.label.login"
            :isRegister="true" />
        <div class="wrapper-login">
            <div class="wrapper-login-content">
                <div class="content-left">
                    <img class="img-cart" src="@/assets/login/cart_new.png" />
                </div>
                <div class="content-right">
                    <div class="wrapper-form-login">
                        <div class="title">{{ lbl.login.login }}</div>
                        <TextInput
                            inputId="username"
                            v-model="username"
                            :inputLbl="lbl.login.username"
                            :isFirstSave="isFirstSave"
                            :isShowErrorLbl="isShowErrorLbl"
                            :errorInfo="arrErrorInfo[0]"
                            :isTextOnly="false"
                        ></TextInput>
                        <Password
                            inputId="password"
                            v-model="password"
                            :inputLbl="lbl.login.password"
                            :inputMinLength="8"
                            :inputMaxLength="15"
                            :isFirstSave="isFirstSave"
                            :isShowErrorLbl="isShowErrorLbl"
                            :errorInfo="arrErrorInfo[1]"
                            :blockAutoComplete="true"
                        ></Password>
                        <div class="forget-password" @click="onClickForgotPassword()">{{ lbl.login.forget_password }}</div>
                        <div class="btn-login font-main" :class="[btnClass]" @click="clickLogin()">{{lbl.login.login}}</div>
                        <!-- <div class="signup">Don’t Have An Account? <span @click="goToPdpa()">Sign Up</span></div> -->
                    </div>
                </div>
            </div>
        </div>
        <Footer />
        <ModalMaster :controller="modalController" />
    </div>
</template>

<script>
import ConfigManager from '@/config/ConfigManager.js';
//helper
import Account from "@/helper/AccountHelper.js"
import FormHelper from "@/helper/FormHelper.js"
import Util from "@/helper/Utility.js"
//component
import TextInput from "@/components/Input/Text.vue";
import Password from "@/components/Input/Password.vue"
import ModalMaster from "@/components/Modal/ModalMaster.vue";
import TopBar from '@/components/Layout/TopBar/TopbarSignUp.vue';
import Footer from '@/components/Layout/Footer/Footer.vue';
// mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js"
//core
import { QueryStringDataBuilder } from '@/core/QueryString/QueryStringDataBuilder';
// service
import { AuthLoginConfigBuilder } from '@/core/Account/config/AuthConfigModel';
import BlobService from "@/service/BlobService.js";


export default {
    name: "Login",
    mixins: [LocaleMixin,ErrorApiMixin,ModalMixin],
    components: {
        TextInput,
        Password,
        ModalMaster,
        TopBar,
        Footer,
    },
    data: function () {
        return {
            username: "",
            password: "",
            blobURL: "",
            isSaveAddress: false,
            isShowErrorLbl: true,
            isFirstSave: true,
            arrErrorInfo: [],

            isDisableBtnLogin: true,
            isLoaded: false,
        }
    },
    computed: {
        btnClass: function() {
            if (!Util.isEmptyStr(this.username) && !Util.isEmptyStr(this.password)) {
                return '';
            }
            return 'disable';
        },
    },
    created: function() {
        this.arrErrorInfo = FormHelper.genErrorInfo(2);
    },
    methods: {
        onSetupModalCompleted: function() {
            this.initLogin();
        },
        initLogin: async function() {
            this.initQueryString();
            var resBlob = await this.initialConfig();
            await this.initialSearchListConfig();
            this.initialCartConfig();
            if (resBlob) {
                let cacheUser = Account.getCacheUser()
                if (cacheUser && cacheUser.channel == "device" || cacheUser && cacheUser.channel == "pos") {
                    window.location.replace('/');
                } else {
                    this.isLoaded = true;
                }
            }
        },
        initQueryString: async function () {
            let app_id = '';
            if (this.$route.query.app_id) {
                app_id = this.$route.query.app_id
            } else {
                this.$route.query.app_id = '5301489996600029'
                app_id = this.$route.query.app_id
            }
            if(!Util.isEmptyStr(app_id)) {
                ConfigManager.setAppId(app_id);
                const query = this.$route.query;
                this.query = new QueryStringDataBuilder()
                .setWithQuery(query)
                .create();

                Account.setCacheQuery(this.query)
                this.blobURL  = `${ConfigManager.getBlobUrl()}/config/b2b_marketplace/${app_id}`;
                this.blobCartURL  = `${ConfigManager.getBlobUrl()}/config/b2b_marketplace`;

            } else {
                this.blobURL  = `${ConfigManager.getBlobUrl()}/config/b2b_marketplace/${ConfigManager.getAppId()}`;
                this.blobCartURL  = `${ConfigManager.getBlobUrl()}/config/b2b_marketplace`;
            }
        },
        initialConfig: async function () {
            return new Promise((resolve, reject) => {
                BlobService.apiGetConfig(`${this.blobURL}`, "config.json")
                .then(res => {
                    this.blobConfig = res.data;
                    Account.setCacheBlob(this.blobConfig)
                    console.log(res.data);
                    resolve(true);
                })
                .catch(ex => {
                    console.log(ex)
                    reject(false);
                });
            });
        },
        initialSearchListConfig: async function () {
            var searchfile = `searchlist/${this.localeCode}.json`;
            return new Promise((resolve, reject) => {
                BlobService.apiGetConfig(`${this.blobURL}`, searchfile)
                .then(res => {
                    console.log(res.data);
                    this.searchlist = res.data;
                    Account.setCacheCustom('searchlist',this.searchlist)
                    resolve(true);
                })
                .catch(ex => {
                    console.log(ex)
                    reject(false);
                });
            });
        },
        initialCartConfig: async function () {
            return new Promise((resolve, reject) => {
                BlobService.apiGetConfig(`${this.blobCartURL}`, "interface_landing_config.json")
                .then(res => {
                    this.cartConfig = res.data;
                    for (var itme in this.cartConfig) {
                        if (itme == this.query.appId) {
                            Account.setCacheCart(this.cartConfig[itme])
                        }
                    }
                    resolve(true);
                })
                .catch(ex => {
                    console.log(ex)
                    reject(false);
                });
            });
        },
        clickLogin: function() {
            if (this.username == '' && this.password == '') return ;
            this.isFirstSave = false;
            if (this.validateForm()) {
                this.apiLogin();
                //this.formModel.setValueFromAddressModel(this.addressModel);
                //this.$emit('onSubmitForm', this.formModel);
                // Util.log("pass", this.formModel);
            }
        },
        apiLogin: function () {
            let loginParams = new AuthLoginConfigBuilder()
                    .setUsername(this.username)
                    .setPassword(this.password)
                    .create()
                    .getParams()
            this.loadingModal.show();
            Account.apiBzbsLogin(loginParams)
                .then(res => {
                    console.log(res);
                    window.location.replace('/');
                }).catch(err => {
                    this.loadingModal.hide();
                    console.log(err);
                    if (err.code === 401 && err.id === 401) {
                        this.alertModal.clearModal()
                        .setTitle(this.lbl.login.err_login.title)
                        .show();
                    } else {
                        this.errorApi(err);
                    }
                });

        },
        validateForm: function() {
            return FormHelper.validate(this.arrErrorInfo);
        },
        goToPdpa: function(){
            this.$router.push('/terms')
        },
        onClickForgotPassword: function(){
            this.$router.push('/forgetpassword')
        }
    }
}
</script>
<style lang="scss">
 @import "@/style/base/base.scss";
.wrapper-form-login{
    .wrap-input{
        .input-box {
            .input-field{
                color: $a-black-333333;
            }
        }
    }
}
</style>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .page-bg {
        width: 100%;
    }

    .wrapper-login {
        display: flex;
        background-image: url('../../../assets/bg/bg-login.png');
        background-repeat: no-repeat;
        background-position: top center;
        background-size: 100%;
        // @include max-mobile {
        //     padding: 100px 20px 0px 20px;
        //     background-image: url("../../../assets/bg/bg-login-mobile.png");
        //     background-repeat: no-repeat;
        //     background-size: 100% 100%;
        // }

        .wrapper-login-content{
            display: flex;
            width: 100%;
            max-width: $max-container-desktop;
            margin: auto;
            padding: 50px 0;
        }
        .content-left {
            @include max-mobile {
                display: none;
            }
            width: 50vh;
            display: flex;
            position: relative;
            .img-cart {
                max-width: 400px;
                width: 100%;
            }
        }
        .content-right {
            @include max-mobile {
                width: 100%;
                height: calc(100vh - 100px);
                background: white;
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
            }

            width: calc(100% - 50vh);
            display: flex;
            .wrapper-form-login {
                width: 100%;
                max-width: 450px;
                background-color: #ffffff;
                padding: 20px;
                margin: auto;
                border-radius: 8px;
                box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.12);

                @include max-mobile {
                    margin-top: 14px;
                    padding: 0px 10px;
                }

                .title {
                    font-family: $ff-semi-bold;
                    font-size: $px16;
                    color: $a-black-333333;
                    text-align: center;
                }

                .forget-password {
                    color: $main-orange-color;
                    text-align: right;
                    padding: 16px 0;
                    text-decoration: underline;
                    cursor: pointer;
                }

                .btn-login {
                    font-size: $px16;
                    color: #fff;
                    text-align: center;
                    background-color: $main-orange-color;
                    padding: 10.5px 10px;
                    border-radius: 10px;
                    margin-top: 20px;
                    cursor: pointer;
                    &.disable {
                        color: $a-gray-999999;
                        background-color: $a-gray-cdcdcd;
                    }
                    @include max-mobile {
                        margin-top: 4px;
                    }
                }

                .signup {
                    padding: 16px 0;
                    text-align: center;
                    color: $a-black-4a4a4a;
                    span {
                        color: $a-orange-f9a601;
                        text-decoration: underline;
                        cursor: pointer;
                    }
                }
            }
        }
    }
</style>
